export default "assets/images/icons/youtube-4b70d832.svg";